import React from 'react'
import _ from 'lodash'

export function getHighlightedText<T>(text: string, searchTerm: string, mapper: ((s: string, index: number) => T)) {
	if (!searchTerm.trim()) {
		return text;
	}
	const parts = searchTerm
		.split(/[*?]/)
		.filter((part) => part)
		.map(x => `(${_.escapeRegExp(x)})`)
	const regex = parts.join('|')
	return text.split(new RegExp(regex, 'gi'))
		.map((part, i) => new RegExp(regex, 'gi').test(part) ? mapper(part, i) : part)
}

interface Props {
	text: string
	searchTerm: string
}

export function HighlightedTextComponent(props: Props) {
	return <>{
		getHighlightedText(
			props.text,
			props.searchTerm,
			(t: string, i: number) => (<span key={i} style={{
				background: '#fff000', color: '#000',
			}}>{t}</span>),
		)
	}</>
}